import {
  EAgentClientAccountingPeriod,
  EAgentClientDocumentType,
  EAgentClientSigningBasis,
  ELeadClientStatus,
} from 'src/containers/LeadCompanyClients';
import {EResellerIds} from 'src/containers/User';

export default {
  title: 'Агенты',
  addAgent: 'агента',
  searchPlaceholder: 'быстрый поиск по агенту',
  createLink: 'Создать ссылку',
  status: {
    [ELeadClientStatus.WAITING]: 'Ожидает активации',
    [ELeadClientStatus.REQUIRES_ATTENTION]: 'Ожидает активации',
    [ELeadClientStatus.ACCEPTED]: 'Активный',
    [ELeadClientStatus.ERROR]: 'Заблокирован',
    [ELeadClientStatus.CANCELLED]: 'Просрочен',
  },
  th: {
    createdAt: 'Дата регистрации',
    company: 'Юрлицо агента',
    status: 'Статус агента',
  },
  filters: {
    status: 'Статус агента',
    period: 'Выберите период',
    clients: 'Агентов',
  },
  createForm: {
    another: 'Другое',
    title: 'Данные компании и контакты',
    commonInfo: 'Общие данные',
    companyName: 'Название юрлица',
    agentName: 'Внутреннее название агента',
    taxNumber: 'ИНН агента',
    kzTaxNumber: 'ИИН агента',
    resellerId: 'Юрисдикция',
    documentInfo: 'Договор и взаиморасчеты',
    signingBasisNumber: 'Номер',
    signingBasisDate: 'Дата',
    certificateHint:
      'Для свидетельства о регистрации ИП укажите серию и номер, например 11 №123456789',
    taxRate: 'Выберите налоговую ставку',
    customTaxRate: 'Налоговая ставка, %',
    signatoryInfo: 'Подписант со стороны агента',
    signingBasis: 'Основание для подписания документов',
    selectSigningBasis: 'Выберите основание',
    signatoryLastName: 'Фамилия подписанта',
    signatoryFirstName: 'Имя подписанта',
    signatoryMiddleName: 'Отчество подписанта (если есть)',
    contactsInfo: 'Контакты',
    contactName: 'ФИО контактного лица',
    email: 'email контактного лица',
    phone: 'Телефон контактного лица',
    responsibleManagerId: 'Ответственный менеджер edna',
    createButton: 'Создать агента ',
  },
  signingBasis: {
    [EAgentClientSigningBasis.CHARTER]: 'Устав',
    [EAgentClientSigningBasis.ENTRUSTMENT]: 'Доверенность',
    [EAgentClientSigningBasis.ORDER]: 'Приказ',
    [EAgentClientSigningBasis.CERTIFICATE]: 'Свидетельство о регистрации ИП',
  },
  taxRateNoVat: {
    [EResellerIds.OSK_ID]: 'НДС не облагается на основании п.1 ст.145 НК РФ',
    [EResellerIds.KZ_ID]: 'НДС не облагается',
    [EResellerIds.MFM_ID]: 'НДС не облагается',
  },
  agentInfo: {
    status: 'Статус агента:',
    companyInfo: 'Данные компании',
    taxNumber: 'ИНН',
    kzTaxNumber: 'ИИН',
    taxRate: 'Налоговая ставка',
    editInfo: 'Редактировать данные',
    documentInfo: 'Взаиморасчеты',
    contractHint: 'Полные условия описаны в вашем договоре с edna',
    documentType: 'Тип соглашения',
    documentNumber: 'Номер договора',
    documentDate: 'Дата подписания договора',
    accountingPeriod: 'Отчетный период',
    commissionPercentage: 'Ставка агентского вознаграждения',
    contactsInfo: 'Контакты',
    responsibleManager: 'Менеджер со стороны edna',
    signingInfo: '{{basis}} {{info}}',
    signingDetails: '{{number}} от {{date}}',
  },
  accountingPeriod: {
    [EAgentClientAccountingPeriod.MONTH]: 'Календарный месяц',
    [EAgentClientAccountingPeriod.QUARTER]: 'Календарный квартал',
  },
  documentType: {
    [EAgentClientDocumentType.AGENT_AGREEMENT]: 'Публичная оферта',
    [EAgentClientDocumentType.AGENT_CONTRACT]: 'Договор',
  },
  supportAction: {
    seeAsClient: 'Посмотреть ЛК',
    payments: 'Платежи клиентов',
    clients: 'Список клиентов',
  },
  editModal: {
    title: 'Редактировать данные компании',
    submitButton: 'Сохранить изменения',
  },
  errors: {
    uniqueAgentName: 'Агент с таким именем уже существует',
    uniqueTaxNumber: 'Агент с таким ИНН уже существует',
    uniqueTaxNumberKz: 'Агент с таким ИИН уже существует',
    uniqueEmail: 'Профиль с таким email уже существует',
    invalidTaxRate: 'Значение не может быть равно {{value}}',
  },
  firstLoginModal: {
    title: 'Проверьте информацию для отчетных документов',
    description:
      'Эти документы будут основанием для выплаты агентского вознаграждения. Подтвердите или отредактируйте данные для формирования акт-отчета.',
  },
  supportButton: {
    payments: 'Платежи клиентов',
    clients: 'Список клиентов',
  },
};
